import { call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../helpers'
import KegsEndpoint from '../persistence/KegEndpoint'
import { reduxFetch } from '../http/reduxFetch'

const kegsTypes = { ...defineTypes('KEGS_INDEX')  }

export const initialState = {
  loading: false,
  loaded: false,
  kegs: []
}

export const actions = {
  getKegs () {
    return { type: kegsTypes.REQUEST }
  },
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case kegsTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case kegsTypes.DESTROY:
      return { ...state, loading: false }
    case kegsTypes.FAILURE:
      return { ...state, loading: false }
    case kegsTypes.SUCCESS:
      return { ...state, loading: false, loaded: true, kegs: action.kegs }
    default:
      return state
  }
}
export const selectors = {
  kegs: (store) => {
    return store['keg'] && store['keg']['kegs']
  },
  loaded: (store) => {
    return store['keg']
      && store['keg']['loaded']
  }
}

export function * kegsSaga () {
  try {
    const response = yield call(reduxFetch, KegsEndpoint.index())
    yield put({ type: kegsTypes.SUCCESS, kegs: response.data })
  } catch (error) {
    yield put({ type: kegsTypes.FAILURE, error })
  }
}

export function * rootSaga () {
  yield takeLatest(kegsTypes.REQUEST, kegsSaga)
}



// WEBPACK FOOTER //
// ./src/sagas/kegs.js